import type { ChatThreadEvent } from '~/App/ChatThreads/@types'

import IncommingProductMessage from './IncommingProductMessage'
import IncommingProductsMessage from './IncommingProductsMessage'

type IncomingImageMessageContainerProps = {
  data: ChatThreadEvent
}

function ShareProductsEvent({ data }: IncomingImageMessageContainerProps) {
  if (
    (data.attributes.sub_type !== 'share_product' &&
      data.attributes.sub_type !== 'share_product_variants') ||
    !data.attributes.additional_fields.product_items?.length
  ) {
    return null
  }

  const item =
    data.attributes.additional_fields.product_items.length === 1
      ? data.attributes.additional_fields.product_items[0]
      : undefined

  if (item) {
    return <IncommingProductMessage event={data} data={item} />
  } else {
    return (
      <IncommingProductsMessage
        event={data}
        data={data.attributes.additional_fields.product_items}
      />
    )
  }
}

export default ShareProductsEvent
